import React, { useState } from 'react';
import '../styles/gemselector.css';

interface Gem {
  name: string;
  type: string;
  tags: string;
  description: string;
  effects: string[];
}

interface GemSelectorProps {
  isOpen: boolean;
  onClose: () => void;
  onSelect: (gem: Gem) => void;
  gems: Gem[];
  type: 'skill' | 'support';
}

export const GemSelector: React.FC<GemSelectorProps> = ({ isOpen, onClose, onSelect, gems, type }) => {
  const [searchTerm, setSearchTerm] = useState('');

  if (!isOpen) return null;

  // Simplified and stricter filtering logic
  const filteredGems = searchTerm.trim() === '' 
    ? gems 
    : gems.filter(gem => {
        const search = searchTerm.toLowerCase().trim();
        const name = gem.name.toLowerCase();
        
        // Only show gems where the name includes the search term
        return name.includes(search);
      });

  // Sort filtered gems alphabetically
  const sortedGems = [...filteredGems].sort((a, b) => 
    a.name.localeCompare(b.name)
  );

  return (
    <div className="gem-selector-overlay" onClick={onClose}>
      <div className="gem-selector" onClick={e => e.stopPropagation()}>
        <div className="selector-header">
          <h2>Select {type} Gem</h2>
          <button onClick={onClose}>×</button>
        </div>
        <input
          type="text"
          placeholder={`Search ${type} gems...`}
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="gem-search"
          autoFocus
        />
        <div className="gem-list">
          {sortedGems.length > 0 ? (
            sortedGems.map((gem) => (
              <div
                key={gem.name}
                className="gem-option"
                onClick={() => onSelect(gem)}
              >
                <h3>{gem.name}</h3>
                <div className="gem-tags">
                  {gem.tags.split(', ').map((tag, index) => (
                    <span key={index} className="gem-tag">{tag}</span>
                  ))}
                </div>
              </div>
            ))
          ) : (
            <div className="no-results">
              No gems found matching "{searchTerm}"
            </div>
          )}
        </div>
      </div>
    </div>
  );
}; 